import API from "./axios";
import AuthAPI from "./authAxios";
import cookieCutter from "cookie-cutter";

export const authorize = (data) => {
  return API.get(`/orgs/token/verify`, { 
    headers: {
      Authorization: `Bearer ${cookieCutter.get("accessToken")}`,
    },
  });
};

export const logout = (data) => {
  // Clear tokens from cookies
  cookieCutter.set("accessToken", "", { expires: new Date(0) });
  cookieCutter.set("refreshToken", "", { expires: new Date(0) });
  
  // Clear email from localStorage
  localStorage.removeItem("email");
  
  return Promise.resolve(true);
};

// Token refresh function - used by interceptors
export const refreshToken = async () => {
  const refreshToken = cookieCutter.get("refreshToken");
  if (!refreshToken) {
    throw new Error("No refresh token available");
  }

  try {
    const response = await AuthAPI.post("/api/auth/refresh-token", {
      refreshToken: refreshToken,
    });

    if (response.status === 200 && response.data.accessToken) {
      // Set new tokens with security flags
      cookieCutter.set("accessToken", response.data.accessToken, {
        path: "/",
        secure: true,
        sameSite: "strict",
      });

      if (response.data.refreshToken) {
        cookieCutter.set("refreshToken", response.data.refreshToken, {
          path: "/",
          secure: true,
          sameSite: "strict",
        });
      }
      return response.data.accessToken;
    } else {
      throw new Error("Failed to refresh token");
    }
  } catch (error) {
    // Clear invalid tokens
    cookieCutter.set("accessToken", "", { expires: new Date(0) });
    cookieCutter.set("refreshToken", "", { expires: new Date(0) });
    throw error;
  }
};

// Simple getter for external use
export const getAccessToken = () => {
  const token = cookieCutter.get("accessToken");
  
  if (!token) {
    return null;
  }
  
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload && payload.email) {
      localStorage.setItem("email", payload.email);
    }
  } catch (error) {
    // Clear invalid token
    cookieCutter.set("accessToken", "", { expires: new Date(0) });
    return null;
  }
  
  return token;
};